import styled from '@emotion/styled/macro'

export const LabelSelectField = styled.select<{
  fieldColor: string
  isLeadingIcon: boolean
  customWidth?: string
}>`
  font-size: 1rem;
  outline: none;
  border: 1px solid gray;
  border-radius: 5px;
  padding: ${({ isLeadingIcon }) =>
    isLeadingIcon ? '1rem 32px' : '1rem 0.7rem'};
  color: gray;
  transition: 0.1s ease-out;
  width: ${({ customWidth }) => customWidth || '200px'};
  &:focus {
    border-color: ${({ fieldColor }) => fieldColor};
  }
`

export const LabelSelectOption = styled.option`
  color: #3c4043;
  display: block;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.25px;
  line-height: 35px;
  margin-left: 8px;
  opacity: 1;
  text-decoration: none;
  text-transform: none;
  &:hover {
    background-color: #f1f3f4 !important;
    cursor: pointer;
  }
`
